"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.stringFromList = void 0;
const arrays_1 = require("../arrays");
function stringFromList({ list = [] }) {
    return (0, arrays_1.oneFromList)({ list });
}
exports.stringFromList = stringFromList;
